// extracted by mini-css-extract-plugin
export default {"button":"menu_button__ushPx","offcanvas":"menu_offcanvas__bavr2","offcanvas_title":"menu_offcanvas_title__Q1LFO","offcanvas_item":"menu_offcanvas_item__Rtppw"};